import axios from "axios";

export const getCountriesData = async () => {
  try {
    const response = await axios.get(
      `http://127.0.0.1:8000/api/global/countries/all`
    );

    console.log("responsedata is : ", response.data);

    return response.data || [];
  } catch (error) {
    return [];
  }
};

export const getStatesData = async (countryId) => {
  try {
    const statesResponse = await axios.get(
      `http://127.0.0.1:8000/api/global/countries/states/${countryId}`
    );
    console.log("responsedata is : ", statesResponse.data);
    return statesResponse.data || [];
  } catch (error) {
    console.error("Error fetching states or cities:", error);
    return [];
  }
};
